import { render, staticRenderFns } from "./DeliveryOrderDetailsModal.vue?vue&type=template&id=5e00ce0b&scoped=true"
import script from "./DeliveryOrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderDetailsModal.vue?vue&type=style&index=0&id=5e00ce0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00ce0b",
  null
  
)

export default component.exports